import React from "react";

interface IcomBtn extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  bordered?: boolean;
  size?: string;
  // secondary?: boolean
}

export default function IcomBtn({
  children,
  className = "",
  bordered,
  size = "normal",
  // secondary,
  ...props
}: IcomBtn) {
  let traitedClassName = [
    className,
    "rounded-xs flex items-center transition-all",
  ];

  switch (size) {
    case "large":
      traitedClassName.push("py-3 px-5");
      break;

    case "normal":
    default:
      traitedClassName.push("py-2 px-4");
      break;
  }

  if (bordered) {
    traitedClassName.push(
      "border-2 border-primary-blue-500",
      "text-primary-blue-500 stroke-primary-blue-500 font-bold",
      "hover:border-primary-blue-400 hover:text-primary-blue-400 hover:stroke-primary-blue-400",
      "active:border-primary-blue-600 active:text-primary-blue-600 active:stroke-primary-blue-600",
      "dark:bg-primary-blue-400 dark:text-white"
    );
  } else {
    traitedClassName.push(
      "bg-primary-blue-400 stroke-white text-white disabled:bg-neutral-gray-400 disabled:text-neutral-gray-700",
      "hover:bg-primary-blue-500",
      "active:bg-primary-blue-600",
      "dark:bg-primary-blue-400 dark:text-white"
    );
  }

  return (
    <button {...props} type="button" className={traitedClassName.join(" ")}>
      {children}
    </button>
  );
}

<div className=""></div>;
